import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const IconFlag = ({ className }) => {
  return (
    <svg
      width='21'
      height='21'
      data-name='Flag'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
    >
      <path
        d='M6.73 1.76L3.9 9.96c3.45 2.12 8 1.17 11.2 3.9l2.64-7.64c-2.56-4.72-7.18-1-11.01-4.46z'
        stroke='#5a5654'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='#3bb7ff'
        strokeWidth='1.5'
      />
      <path
        d='M6.66 1L1 17.44'
        fill='none'
        strokeWidth='2'
        stroke='#5a5654'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

IconFlag.propTypes = {
  className: PropTypes.string
}

const StyledIconFlag = styled(IconFlag)`
  height: 21px;
  width: 21px;
`

export default StyledIconFlag
